import { useHistory, useLocation } from 'quartz-routing/react-router';
import I18n from 'I18n';
import { SideNav, SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { PortalsAppLayout } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AppLayout({
  children
}) {
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;
  return /*#__PURE__*/_jsx(PortalsAppLayout, {
    history: history,
    sideNavChildren: /*#__PURE__*/_jsxs(SideNav, {
      "aria-label": I18n.text('app.nav.ariaLabel'),
      headingText: I18n.text('app.nav.ariaLabel'),
      children: [/*#__PURE__*/_jsx(SideNavItem, {
        title: I18n.text('app.nav.tokenExplorer'),
        active: currentPath === '/' || currentPath === '/token-explorer',
        onClick: () => history.push('/token-explorer')
      }), /*#__PURE__*/_jsx(SideNavItem, {
        title: I18n.text('app.nav.projects'),
        active: currentPath.startsWith('/projects'),
        onClick: () => history.push('/projects')
      }), /*#__PURE__*/_jsx(SideNavItem, {
        title: I18n.text('app.nav.formExample'),
        active: currentPath === '/form-example',
        onClick: () => history.push('/form-example')
      })]
    }),
    children: children
  });
}